<template>
  <div class="home">
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'hkkfView',
  mounted() {
    this.$router.push('/hkkf')
  },
});
</script>
